<template>
  <PublicPopup ref="PopupRef" border-color="var(--login-popup-border)">
    <template #content>
      <div class="user-agreement-popup chxy-column-c-c">
        <div class="user-agreement-content">
          <p class="title">{{ $t('user-agreement-popup-index.title') }}</p>
          <p class="paragraph">{{ $t('user-agreement-popup-index.p1') }}</p>
          <p class="paragraph">{{ $t('user-agreement-popup-index.p2') }}</p>
          <p class="paragraph">{{ $t('user-agreement-popup-index.p3') }}</p>
          <p class="paragraph">{{ $t('user-agreement-popup-index.p4') }}</p>
          <p class="paragraph">{{ $t('user-agreement-popup-index.p5') }}</p>
        </div>
        <div class="button" @click="handlePopupClose">
          {{ $t('user-agreement-popup-index.accept') }}
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}
const handlePopupClose = () => {
  PopupRef.value.close()
}

const emit = defineEmits(['close'])

defineExpose({
  open,
})
</script>

<style lang="scss" scoped>
.user-agreement-popup {
  width: 75vw;

  .title,
  .paragraph {
    font-size: 10px;
    color: var(--user-agreement-popup-content-text);
  }

  .title {
    text-align: center;
  }

  .user-agreement-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 35vh;
    line-height: 1.2;
    overflow-y: auto;
  }
  .button {
    margin: 25px 0;
    width: 100%;
    height: 35px;
    line-height: 35px;
    text-align: center;
    background: var(--user-agreement-popup-confirm-bg);
    color: var(--user-agreement-popup-confirm-text);
    font-size: 14px;
    border-radius: 7px;
  }
}
</style>
